import { render, staticRenderFns } from "./credit-admin.vue?vue&type=template&id=a64d761c&"
import script from "./credit-admin.vue?vue&type=script&lang=js&"
export * from "./credit-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports